import { ActionIcon, Tooltip } from '@mantine/core';
import { IconMessage } from '@tabler/icons-react';
import { ReactElement } from 'react';

type TextButtonProps = {
  onClick: () => void;
  size?: number;
  tooltip?: string;
};

/**
 * The text counterpart of `CallButton`, drawn the same way so the two read as a pair.
 *
 * Unlike `CallButton` it sends nothing itself: a text needs a message, so it opens whatever
 * composer the caller owns. Stops propagation because it lives on rows that navigate.
 */
export function TextButton({ onClick, size = 14, tooltip = 'Text' }: TextButtonProps): ReactElement {
  return (
    <Tooltip label={tooltip}>
      <ActionIcon
        variant="light"
        color="blue"
        aria-label={tooltip}
        onClick={(event) => {
          event.stopPropagation();
          onClick();
        }}
      >
        <IconMessage size={size} />
      </ActionIcon>
    </Tooltip>
  );
}
